export default __webpack_public_path__ + "static/target-6f0f4d722b0bc2ff667ed348da501668.png";